import React from 'react';
import { MoreHorizontal as LucideMoreHorizontal } from 'lucide-react';

interface MoreHorizontalProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const MoreHorizontal: React.FC<MoreHorizontalProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideMoreHorizontal width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default MoreHorizontal;
